
const utils = {
	openUrl: null
};

export { utils };